import React from "react";
import Auxiliary from "../../Components/HOC/Auxiliary";
// import logo from "../../Assets/googlelogo.png";
// import SearchInput from "../../Components/SearchInput/SearchInput";
import "./SearchResults.css";
// import {Avatar} from "@material-ui/core";
// import {Link, NavLink} from "react-router-dom";
// import {CgMenuGridR} from  "react-icons/cg"; 
// import "../../Components/Header/Header.css";
// import {HiSearch} from "react-icons/hi";
// import {RiVideoLine} from "react-icons/ri";
// import {BsImages} from "react-icons/bs";
// import {BiNews, BiDotsVerticalRounded, BiMap} from "react-icons/bi";
import {connect} from "react-redux";
import ResultCard from "../../Components/ResultCard/ResultCard";
import Footer from "../../Components/Footer/Footer";
import SearchResultsHeader from "../../Components/SearchResultsHeader/SearchResultsHeader";

const SearchResults =(props)=>{
    const data = props.receivedData;
    // console.log(data);
    // useEffect(()=>{
    //     document.title = "Google - Search results";
    // },[]);
    return(
        <Auxiliary>
            <section id="results" className="main_search_results_container">
                <SearchResultsHeader />

                <div className="search-info desktop-only">
                    <span>About {data?.searchInformation?.formattedTotalResults} results ({data?.searchInformation?.searchTime} seconds)</span>
                </div>
                <div className="search_result_cards">
                    {
                        data?.items?.map((item, i)=>{
                            return(
                                <ResultCard key={item?.cacheId ? item?.cacheId : "#" + i} link={item?.link} displayLink={item?.displayLink} title={item?.title} snippet={item?.snippet} />
                            )
                        })
                    }
                </div>
                <Footer />
            </section>
        </Auxiliary>
    )
}
const mapStateToProps= state=>{
    return{
        receivedData: state.receivedData
    }
}
export default connect(mapStateToProps)(SearchResults);